import { useEffect, useState } from "react"
import { getRecibo, handleCheckQuitaScoring } from "./handlers"
import Articulo from '../../components/Articulo/index'
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner"
import { Button } from "react-bootstrap"

const Recibo = (props) => {
  const { recibo, setRecibosPagos } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingCheckScoring, setIsLoadingCheckScoring] = useState(false)
  const [reciboFisico, setReciboFisico] = useState(null)
  const date = new Date(recibo.fecha_pago)

  useEffect(() => {
    getRecibo(recibo.numero_recibo, setReciboFisico, setIsLoading)
  }, [recibo.numero_recibo])

  return (
    <div>
      {isLoading ? <PulseOpacitySpinner /> : reciboFisico && (
        <div>
          <h6>Monto: ${recibo.monto}</h6>
          <h6>Fecha de pago: {date.toLocaleDateString("es-AR", { timeZone: "GMT" })}</h6>
          <h6>Acta Asociada: {recibo.acta_asociada}</h6>
          <div className='d-flex flex-wrap gap-2'>
            {recibo.articulos ? (
              <div className="mt-8">
                <h6 className="mb-2">
                  Articulos:
                </h6>
                <div>
                  {recibo.articulos && recibo.articulos.length > 0 ?
                    recibo.articulos.map((articulo, i) => (
                      <Articulo key={articulo.codigo + i} articulo={articulo} index={i} />
                    )) : <p>Sin articulos seleccionados</p>}
                </div>
              </div>
            ) : null}
          </div>
          <div style={{ height: reciboFisico?.recibo ? '620px' : '250px' }}>
            <iframe src={reciboFisico?.recibo?.urlRecibo} width='100%' height='100%' title={`Recibo ${reciboFisico?.numeroRecibo?.notacionStandard}`} />
          </div>
          {/* {!recibo.check_scoring &&
            <Button className="mt-4" onClick={() => handleCheckQuitaScoring(recibo?.acta?.id, setRecibosPagos, setIsLoadingCheckScoring)}>
              Marcar como scoring descontado
            </Button>
          } */}
        </div>
      )}
    </div>
  )
}
export default Recibo